<template>
  <div class="sscontainer-footer-footer appli"><h3>Télécharger <br/>COOLOC</h3>
    <ul class="menu-picto-footer">
      <li class="ios"><a href="#" title="Télécharger l\'appli Ios COOLOC"><span
        class="invisible">Appli Ios COOLOC</span></a></li>
      <li class="android"><a href="#"
                             title="Télécharger l\'appli Android COOLOC"><span
        class="invisible">Appli Android COOLOC</span></a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-apps',
}
</script>
